module.exports = __webpack_public_path__ + "static/img/proximanova-semibold-webfont.9fae06d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximanova-semibold-webfont.svg
// module id = U+1z
// module chunks = 1